import { Fragment } from "react"
import type { DataList } from "../../../../../types"
import { Toggle } from "components/actions/Toggle"
import toast from "react-hot-toast"
import { useApi, useToggle } from "utils"


export function IsActive(props: { id: DataList; refetch?: () => void }) {
    // Hooks
    const api = useApi()
    const { isActive, toggle } = useToggle(props.id.is_deleted ?? false)

    const onSubmit = (value: DataList) => {
        return new Promise<void>((resolve) => {
            toggle()
            toast.promise(
                api.put("/location/changestatus",
                    {
                        location_id: value.location_id,
                        locationdel: !isActive
                    }),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message
                }
            ).then(() => {
                if (props.refetch) {
                    props.refetch()
                }
            }).catch(() => {
                toggle()
            }).finally(resolve)
        })
    }

    return (
        <Fragment>
            <Toggle
                label="Soft Delete"
                isChecked={isActive} 
                onClick={() => {
                    onSubmit(props.id);
                }} />
        </Fragment>
    )
}